import { Workspace } from "../../adapters/workspace";
import { present } from "../../../utils/presenter";
import { Interactor } from "./types";

function createInteractor(workspace: Workspace): Interactor {
  return () => present(workspace.get());
}

export type { Interactor };

export { createInteractor };
